import { Typography } from "@mui/material";
import Logo from "components/Logo";
import { Link } from "react-router-dom";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useMegaMenuRedux } from "redux/slices/mega-menu/hooks/useMegaMenuRedux";
import { useLinks } from "hooks/useLinks";

export const AppBarLogo = () => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { toggleDrawer } = useMegaMenuRedux();
	const links = useLinks();

	const handleLogoClick = () => {
		window.scrollTo(0, 0);
		toggleDrawer(false);
		reportEvent("logo_click", { source: "mega_menu" });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "logo_click",
			event_type: "top navbar",
			action: "logo_click",
			source: "navbar"
		});
	};

	return (
		<Typography
			variant="h6"
			noWrap
			component="h1"
			sx={{
				flexGrow: 1,
				display: { lg: "flex" },
				justifyContent: { lg: "left" },
				background: { lg: "none" }
			}}
		>
			<Link to={links.home.path} onClick={handleLogoClick}>
				<Logo />
			</Link>
		</Typography>
	);
};
